import React from 'react';
import { theme } from 'antd';

interface ChartTooltipProps {
  active?: boolean;
  payload?: any[];
  label?: string;
  formatter?: (value: number, name: string) => string;
}

const defaultFormatter = (value: number) => value.toLocaleString('ru-RU');

export const ChartTooltip: React.FC<ChartTooltipProps> = ({
  active,
  payload,
  label,
  formatter = defaultFormatter,
}) => {
  const { token } = theme.useToken();

  if (!active || !payload || payload.length === 0) return null;

  return (
    <div
      style={{
        minWidth: 150,
        padding: '8px 10px',
        background: token.colorBgElevated,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadius,
        boxShadow: token.boxShadowSecondary,
      }}
    >
      {label && (
        <div style={{ marginBottom: 6, fontSize: 12, fontWeight: 600, color: token.colorText }}>
          {label}
        </div>
      )}
      {payload.map((entry) => (
        <div
          key={entry.dataKey ?? entry.name}
          style={{ display: 'flex', justifyContent: 'space-between', gap: 12, fontSize: 12, lineHeight: '18px' }}
        >
          <span style={{ color: entry.color }}>{entry.name}</span>
          <span style={{ fontWeight: 600, color: token.colorText }}>
            {formatter(Number(entry.value ?? 0), entry.name)}
          </span>
        </div>
      ))}
    </div>
  );
};